import React from 'react';

export const Statelist={
	
"AN": "Andaman and Nicobar",
"AP": "Andhra Pradesh",
"AR": "Arunachal Pradesh",
"AS": "Assam",
"BR": "Bihar",
"CH": "Chandigarh",
"CT": "Chhattisgarh",
"DL": "Delhi",
"DN": "Dadra and Nagar Haveli",
"GA": "Goa",
"GJ": "Gujarat",
"HP": "Himachal Pradesh",
"HR": "Haryana",
"JH": "Jharkhand",
"JK": "Jammu and Kashmir",
"KA": "Karnataka",
"KL": "Kerala",
"LA": "Ladakh",
"LD": "Lakshadweep",
"MH": "Maharashtra",
"ML": "Meghalaya",
"MN": "Manipur",
"MP": "Madhya Pradesh",
"MZ": "Mizoram",
"NL": "Nagaland",
"OR": "Odisha",
"PB": "Punjab",
"PY": "Puducherry",
"RJ": "Rajasthan",
"SK": "Sikkim",
"TG": "Telangana",
"TN": "Tamil Nadu",
"TR":"Tripura",
"TT": "India",
"UP": "Utter Pradesh",
"UT": "Uttranchal",
"WB":"West Bengal" 
}

export default Statelist;

